export const config: Record<string, any> = {
  "/api/accounts/password-reset-request/": {
    message: "Request password reset",
    description:
      "Password request sent successfully. Admin will be in contact with you shortly.",
  },
};
